export default "__VITE_ASSET__Bv85KxIh__"